import { Card, Col, Image, Row, Typography } from "antd";
import { useIntl } from "react-intl";
import "./Download.css";
import { useEffect } from "react";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import { IAppDownloadLink } from "../../Orchestrator/Types/Interface/ICmsAppDownloadLink";
import Link from "next/link";
import { _eventBus } from "../../core/events/EventBus";
import { evtTree } from "../../Orchestrator/ConstantTree";

const Download = () => {
  const intl = useIntl();

  const [appDownloadLink] = useRecState<IAppDownloadLink>("appDownloadLinkAtom");
  const {playStoreLink = "#", appStoreLink = "#", playStoreQrLink, appStoreQrLink} = appDownloadLink || {};

  useEffect(() => {
    setTimeout(() => {
      _eventBus.emit({
        eventName: evtTree.TopBar.getCmsAppDownloadLinkAndQr,
      })
    }, 500)
  }, [])

  if (!appDownloadLink) return null;

  return (
    <Card className="bg-F7F2EE shadow-unset radius-24 download-card">
      <Row
        gutter={[16, 16]}
        className="align-items-center"
        justify="space-between"
      >
        <Col
          xs={24}
          sm={24}
          xl={12}
          className="h-fit-content pr-24"
        >
          <Typography.Text className="fw-700 text-uppercase heading">
            {intl.formatMessage({ id: "bookManageJourney" })}
          </Typography.Text>
        </Col>
        <Col xs={24} sm={24} xl={12} className="text-center">
          <div className="download-content">
            <div className="download-section">
              <Link href={playStoreLink} target="_blank" rel="noopener noreferrer" className="d-flex">
                <Image
                  src={playStoreQrLink}
                  alt="Download on Play Store"
                  height={60}
                  width={60}
                  preview={false}
                />
              </Link>
              <div>
                <Link href={playStoreLink} target="_blank" rel="noopener noreferrer" className="d-flex">
                  <img
                    src="/images/play_store.png"
                    alt="Download on Play Store"
                    width={148}
                    height={44}
                  />
                </Link>
                <Typography className="ff-inter fs-14 color-2F3034 fw-500 w-fit-content lh-normal mt-4">
                  {intl.formatMessage({ id: 'scanToDownload' })}
                </Typography>
              </div>
            </div>

            <div className="download-section">
              <Link href={appStoreLink} target="_blank" rel="noopener noreferrer" className="d-flex">
                <Image
                  src={appStoreQrLink}
                  alt="Download on App Store"
                  height={60}
                  width={60}
                  preview={false}
                />
              </Link>
              <div>
                <Link href={appStoreLink} target="_blank" rel="noopener noreferrer" className="d-flex">
                  <img
                    src="/images/app_store.png"
                    alt="Download on App Store"
                    width={148}
                    height={44}
                  />
                </Link>
                <Typography className="ff-inter fs-14 color-2F3034 fw-500 w-fit-content lh-normal mt-4">
                  {intl.formatMessage({ id: 'scanToDownload' })}
                </Typography>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default Download;
